import { render } from "./treasure-hunt.layout.vue?vue&type=template&id=3eea98a1"
const script = {}

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__